<template>
  <v-dialog v-model="show" max-width="800px">
    <Gallery @select="selectImage" :dialog="dialog" />
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" class="text-center">
            <v-responsive class="pt-4">
              <img
                aspect-ratio="1"
                :src="object.imagen ? object.imagen : imageDefault"
              />
            </v-responsive>
          </v-col>
          <!-- <v-col v-if="!detalle" cols="12" md="6">
            <span>Sube una imágen</span>
            <v-file-input
              :rules="rulesImage"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Imagen"
              name="file0"
              prepend-icon="photo_camera"
              @change="obtenerImagen"
            ></v-file-input>
          </v-col> -->

          <v-col v-if="!detalle" cols="12" md="6">
            <span class="align-center">Asignar imágen desde la galería</span>
            <v-btn class="mx-2" @click="galleryFn" fab dark color="primary">
              <v-icon dark>
                image
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="object.grupo"
              :items="gruposArr"
              dense
              label="Grupo"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-checkbox v-model="object.dalquiler" label="Para Alquilar"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="object.aventa" label="A la venta"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="object.taller" label="En taller"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="object.vendido" label="Vendido"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.matricula"
              required
              label="Matrícula"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.marca"
              label="Marca"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.modelo"
              label="Modelo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.color"
              label="Color"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.bastidor"
              label="Bastidor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.puertas"
              label="Puertas"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.km_actual"
              label="Km Actual"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.km_compra"
              label="Km Compra"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.plazas"
              label="Plazas"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.tanque"
              label="Tanque"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="object.tipo_combustible"
              :items="tipo_combustibleArr"
              dense
              label="Tipo de combustible"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="object.combustible_actual"
              :items="combustible_actualArr"
              dense
              label="Combustible actual"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-checkbox v-model="object.radio" label="Radio"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="object.transmision"
              :items="transmisionArr"
              dense
              label="Transmisión"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-menu
              v-model="dateFC"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.fecha_compra"
                  label="Fecha Compra"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FC"
                @input="dateFC = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="dateFA"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.fecha_alta"
                  label="Fecha Alta"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FA"
                @input="dateFA = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="dateFM"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.fecha_matriculacion"
                  label="Fecha Matriculación"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FM"
                @input="dateFM = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="dateFL"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.fecha_limite"
                  label="Fecha Limite"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FL"
                @input="dateFL = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="dateFITV"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="object.fecha_itv"
                  label="Fecha ITV"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_FITV"
                @input="dateFITV = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.precio_compra"
              label="Precio Compra"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              type="text"
              v-model="object.precio_venta"
              label="Precio Venta"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-textarea
              type="text"
              v-model="object.observaciones"
              outlined
              name="input-7-4"
              label="Observaciones"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="object" color="blue darken-1" text @click="close">
          Volver
        </v-btn>
        <v-btn v-else color="blue darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-btn v-if="!detalle" color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Gallery from "../Gallery";

export default {
  data() {
    return {
      dialog: false,
      imageDefault:"https://futureuniversity.com/wp-content/uploads/sites/3/2015/02/default-placeholder-1024x1024-570x321.png",
      image: "",
      rulesImage: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Avatar size should be less than 2 MB!",
      ],
      gruposArr: [],
      transmisionArr: [
        { text: "Manual", value: false },
        { text: "Automático", value: true },
      ],
      tipo_combustibleArr: [
        { text: "Petrol 95", value: 1 },
        { text: "Gasoil", value: 2 },
        { text: "Hybrid", value: 3 },
        { text: "Electric", value: 4 },
      ],
      combustible_actualArr: [
        { text: "Vacio", value: 0 },
        { text: "1/8", value: 1 },
        { text: "1/4", value: 2 },
        { text: "3/8", value: 3 },
        { text: "1/2", value: 4 },
        { text: "5/8", value: 5 },
        { text: "3/4", value: 6 },
        { text: "Full", value: 7 },
      ],
      date_FC: new Date().toISOString().substr(0, 10),
      date_FA: new Date().toISOString().substr(0, 10),
      date_FM: new Date().toISOString().substr(0, 10),
      date_FL: new Date().toISOString().substr(0, 10),
      date_FITV: new Date().toISOString().substr(0, 10),
      dateFC: false,
      dateFA: false,
      dateFM: false,
      dateFL: false,
      dateFITV: false,
      grupo: this.object.grupo,
      matricula: this.object.matricula,
      marca: this.object.marca,
      modelo: this.object.modelo
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
    detalle: Boolean,
  },
  components: {
    Gallery,
  },
  validations: {
    grupo: { required },
    matricula: { required },
    marca: { required },
    modelo: { required },
  },
  created() {
    moment.locale("ES");
    this.selectGruposFn();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("grupoNamespace", ["grupos"]),
    // shoFalse() {
    //   if(!this.show)
    // },
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edición de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
    grupoErrors() {
      const errors = [];
      if (!this.$v.grupo.$dirty) return errors;
      // !this.$v.name.decimal && errors.push('Name must be a number')
      !this.$v.grupo.required &&
        errors.push("Debes seleccionar el grupo al que pertenece");
      return errors;
    },
    matriculaErrors() {
      const errors = [];
      if (!this.$v.matricula.$dirty) return errors;
      // !this.$v.name.decimal && errors.push('Name must be a number')
      !this.$v.matricula.required && errors.push("La matricula del coche es requerida");
      return errors;
    },
    marcaErrors() {
      const errors = [];
      if (!this.$v.marca.$dirty) return errors;
      // !this.$v.name.decimal && errors.push('Name must be a number')
      !this.$v.marca.required && errors.push("La marca del coche es requerida");
      return errors;
    },
    modeloErrors() {
      const errors = [];
      if (!this.$v.modelo.$dirty) return errors;
      !this.$v.modelo.required && errors.push("El modelo del coche es requerido");
      return errors;
    },
  },
  methods: {
    selectImage(url) {
      this.dialog = false;
      this.object.imagen = url;
    },
    obtenerImagen(file) {
      this.object.image = file;
    },
    galleryFn() {
      this.dialog = true;
    },
    selectGruposFn() {
      let me = this;
      let arr = this.grupos;
      arr.forEach((x) => {
        me.gruposArr.push({ text: x.nombre, value: x.id });
      });
    },
    guardar() {
      debugger;
      (this.object.fecha_compra = this.date_FC),
        (this.object.fecha_alta = this.date_FA),
        (this.object.fecha_matriculacion = this.date_FM),
        (this.object.fecha_limite = this.date_FL),
        (this.object.fecha_itv = this.date_FITV),
        this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    date_FC: function(val) {
      this.object.fecha_compra = moment(val).format("LL");
    },
    date_FA: function(val) {
      this.object.fecha_alta = moment(val).format("LL");
    },
    date_FM: function(val) {
      this.object.fecha_matriculacion = moment(val).format("LL");
    },
    date_FL: function(val) {
      this.object.fecha_limite = moment(val).format("LL");
    },
    date_FITV: function(val) {
      this.object.fecha_itv = moment(val).format("LL");
    },
  },
};
</script>

<style></style>
